module.exports = "/fonts/vendor/@flaticon/flaticon-uicons/css/uicons-solid-straight-4DZ3VA4V.woff2?10a42bec98afb83391ab5e142ff5142b";